import i18n from 'i18next';
import { createSlice } from '@reduxjs/toolkit';
import { toast } from '@oliasoft-open-source/react-ui-library';
import { apiCallBegan } from 'api/api.ts';
import translations from 'src/internationalisation/translation-map.json';
import { IUnitTemplatesState } from 'client/common/interfaces/unit-templates.interfaces.ts';

const initialState: IUnitTemplatesState = {
  isFetching: false,
  activeTemplate: { template: null, configuration: [] },
};

const unitTemplates = createSlice({
  name: 'unitTemplates',
  initialState,
  reducers: {
    activeTemplateRequested: (campaigns) => {
      campaigns.isFetching = true;
    },
    activeTemplateFetched: (campaigns, action) => {
      campaigns.isFetching = false;
      campaigns.activeTemplate = action.payload;
    },
    activeTemplateFailed: (campaigns) => {
      campaigns.isFetching = false;
    },
  },
});

export const { activeTemplateRequested, activeTemplateFetched, activeTemplateFailed } = unitTemplates.actions;
export default unitTemplates.reducer;

export const getActiveTemplate = () =>
  apiCallBegan({
    url: `/api/unit-templates/active`,
    method: 'GET',
    onStart: activeTemplateRequested.type,
    onSuccess: (response) => ({
      type: activeTemplateFetched.type,
      payload: response,
    }),
    onError: () => {
      toast({
        message: {
          type: 'Error',
          content: i18n.t(translations.unitTemplates_failedToGetActiveTemplate) as string,
        },
      });
      return {
        type: activeTemplateFailed.type,
      };
    },
  });
